import { render } from "./FileFormView.vue?vue&type=template&id=27ee441c&scoped=true"
import script from "./FileFormView.vue?vue&type=script&lang=js"
export * from "./FileFormView.vue?vue&type=script&lang=js"

import "./FileFormView.vue?vue&type=style&index=0&id=27ee441c&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ee441c"]])

export default __exports__